import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import About from './pages/About.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '趋致科技-首页'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        title: '趋致科技-关于'
      }
    }
  ]
})